<template>
  <div id="hres92u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres92uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHres92uSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres92u/mutation-types'
import detail from 'components/hres92u/detail'
import moment from 'moment'

export default {
  name: 'hres92u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres92uColumnsLabels()
    this.receivedHres92uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES92U_INDEX_DISP,
      detailDisp: types.GET_HRES92U_DETAIL_DISP,
      columns: types.GET_HRES92U_COLUMNS,
      labels: types.GET_HRES92U_LABELS,
      index: types.GET_HRES92U_INDEX,
      indexSelected: types.GET_HRES92U_INDEX_SELECTED,
      detail: types.GET_HRES92U_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHres92uDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES92U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES92U_PAGE,
      receivedHres92uColumnsLabels: types.RECEIVED_HRES92U_COLUMNS_LABELS,
      receivedHres92uIndex: types.RECEIVED_HRES92U_INDEX,
      receivedHres92uDetail: types.RECEIVED_HRES92U_DETAIL,
      postHres92uSendApprove: types.POST_HRES92U_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?8baf7946